// extracted by mini-css-extract-plugin
export default {"chart":"styles_chart__AcnrT","small":"styles_small__Sp3iZ"};